import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../auth/hooks/useAuth';
import NavbarComp from '../../shared/components/Navbar';
import FilterCardSearch from './components/FilterCardSearch';
import ProductCardSearch from './components/ProductCardSearch';
import { useProducts } from '../products/hooks/useProducts';
import { useFavorite } from '../products/hooks/useFavorite';
import { useCarts } from '../products/hooks/useCart';

const SearchPage = () => {

    const {
        products,
        searchProductPost,
        loading,
        fetchProducts,
        filterProductPost } = useProducts();
    const { addFavoriteProduct, removeFavoriteProduct } = useFavorite();
    const { addProductCart } = useCarts();


    const navigate = useNavigate();

    let bbb = products;

    const { validate } = useAuth();

    const [user, setUser] = useState()

    const [searchTerm, setSearchTerm] = useState('');

    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState({
        category: "",
        price: "",
        age: "",
        type: "",
        sex: ""
    });

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    };

    useEffect(() => {
        (async () => {
            const userData = await validate();
            setUser(userData);
        })();
    }, [validate]);

    const handleSearchProduct = (value) => {
        searchProductPost(value)
    }

    const submitFilter = () => {

        const data = {
            sex: filters.sex,
            categoryString: filters.category,
            ageGroupProductString: filters.age,
            starting_price: filters.price,
            typeProductString: filters.type,
        }

        filterProductPost(data)
    }

    const handleOnAddToCart = (data) => {
        const rowDataAddCart = {
            qty: 1,
            product: data
        }
        addProductCart(rowDataAddCart);
        navigate('/cart');
    }

    const handleAddFavoriteProduct = async (data) => {
        Swal.fire({
            title: 'Loading...',
            text: 'Please wait while we process your request.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        try {
            // Simulate an async operation (e.g., API call)
            await new Promise(async (resolve) => {

                addFavoriteProduct({ product: data });
                setTimeout(resolve, 500)
            });

            // After the async operation is complete, close the loading modal
            Swal.close();

            // Optionally, show a success message
            // Swal.fire('Success!', 'Your operation completed successfully.', 'success');
        } catch (error) {
            Swal.close();
            Swal.fire('Error!', 'There was a problem processing your request.', 'error');
        }
    }

    return (
        <>
            <NavbarComp searchProduct={handleSearchProduct} />
            <Container style={{
                backgroundColor: 'none',// Make sure the path is correct
                backgroundPosition: 'top right', // Position the image at the top-right corner
                backgroundSize: 'auto', // Adjust the size of the background image
                height: 'auto', // Make the container take full height (optional)    
                overflowY: 'hidden',
                overflowX: 'hidden',
                paddingBottom: '5%'
            }}>
                {/* <Container fluid
                    style={{
                        backgroundColor: '#f0f0f0',// Make sure the path is correct
                        backgroundPosition: 'top right', // Position the image at the top-right corner
                        backgroundSize: 'auto', // Adjust the size of the background image
                        maxWidth: '1200px',
                        height: '100vh',
                    }}> */}
                {/* <Topbar /> */}
                <Row style={{
                    backgroundColor: 'none',// Make sure the path is correct
                    backgroundPosition: 'top right', // Position the image at the top-right corner
                    backgroundSize: 'auto', // Adjust the size of the background image
                    height: '17%', // Make the container take full height (optional)
                    paddingBottom: '10px'
                }}>
                    <img
                        src="https://picsum.photos/1500/300"  // Example image
                        alt="Banner"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "fill",  // Ensures the image covers the entire container without distortion
                        }}
                    />
                </Row>

                <Row>
                    <Col xs={12} md={3} className='g-0'>
                        <Card border='0' style={{ backgroundColor: 'transparent' }}>
                            <Card.Body style={{ backgroundColor: 'transparent' }}>
                                <FilterCardSearch
                                    open={open}
                                    setOpen={setOpen}
                                    filters={filters}
                                    handleFilterChange={handleFilterChange}
                                    submitFilter={submitFilter}
                                />
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col xs={12} md={9}>
                        <Row>
                            <ProductCardSearch
                                products={bbb}
                                onAddToFavorites={handleAddFavoriteProduct}
                                onAddToCart={handleOnAddToCart}
                                loading={loading} />
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default SearchPage;